import { KoobBadge, KoobTooltip } from '@koob/ui';
import React from 'react';
import { formatDate } from '@koob/dates';

export default function CheckoutHotelRoomTag({
  label,
  value,
  startAt,
  endAt,
  size,
}) {
  const tip =
    startAt && endAt
      ? `${formatDate(startAt, 'DD/MM/YYYY')} - ${formatDate(endAt, 'DD/MM/YYYY')}`
      : '';

  const badgeColor = () => {
    switch (value) {
      case 'refundable':
      case 'room_refundable':
        return 'green';
      case 'non_refundable':
      case 'room_non_refundable':
        return 'red';
      default:
        return 'gray';
    }
  };

  return (
    <KoobTooltip
      tip={tip}
      disabled={!tip}
      color="purple"
      hasArrow={false}
      position="bottom"
    >
      <KoobBadge color={badgeColor()}>{label}</KoobBadge>
    </KoobTooltip>
  );
}
